// 属性
import service from './prototypes/index.js'
// 组件
import Placeholder from './components/cm-placeholder/index.vue';
// 指令
import focus from './directives/focus';
import clickoutside from './directives/clickoutside';
import numberOnly from './directives/numberOnly';
// 过滤器
import imageFormat from './filters/imageFormat';
import dateFormat from './filters/dateFormat';
import hrefFormat from './filters/hrefFormat';

// 混入
export default {
  install(Vue, option) {
    // 注册属性
    Vue.prototype.$ = service;

    // 注册组件
    Vue.component('cm-placeholder', Placeholder);

    // 注册指令
    Vue.directive('focus', focus);
    Vue.directive('clickoutside', clickoutside);
    Vue.directive('numberOnly', numberOnly);

    // 注册过滤器
    Vue.filter('imageUrl', imageFormat.url);
    Vue.filter('imagePath', imageFormat.path);
    Vue.filter('dateFormat', dateFormat);
    Vue.filter('hrefFormat', hrefFormat);

    // 注册混入
    // Vue.mixin({})
  }
}



// WEBPACK FOOTER //
// ./src/assets/plugin/index.js